import React from "react";

import * as classes from "./Content.module.css";

const Content = ({ children, style, color, grow, border }) => {
  let backgroundStyle = color
    ? {
        ...style,
        backgroundColor: `var(--main-${color})`,
        color: color === "grey" ? "black" : "white",
      }
    : style;

  backgroundStyle = border
    ? { ...backgroundStyle, borderTop: "1px solid #ccc" }
    : backgroundStyle;

  backgroundStyle = grow
    ? { ...backgroundStyle, flexGrow: grow ? 1 : 0 }
    : backgroundStyle;

  return (
    <section className={classes.container} style={backgroundStyle}>
      <div className={classes.content}>{children}</div>
    </section>
  );
};

export default Content;
